<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    this.$store.dispatch('site/fetchSiteInfo')
    // 省市区树只拉取一次，各页共用（如添加/编辑学员）
    this.$store.dispatch('common/ensureRegionTree')
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  width: 100%;
  height: 100vh;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.el-table tr{
  background: none !important;
}
.el-table th.el-table__cell.is-leaf{
  background: none !important;
}
.el-table td.el-table__cell.is-leaf{
  background: none !important;
}
.el-table th.el-table__cell.is-leaf{
  background: none !important;
}

/* 全局样式 - 放在 App.vue 的 style 标签中（不加 scoped） */
.el-cascader-panel {
  height: 400px !important;
}

.el-cascader-menu__wrap {
  height: 100% !important;
}

/* 或者更精确地设置 */
.el-cascader__dropdown .el-cascader-panel {
  height: 400px !important;
}

.el-cascader__dropdown .el-cascader-menu {
  height: 100% !important;
}

.el-cascader__dropdown .el-cascader-menu__wrap {
  height: 100% !important;
}
</style>

